import { api } from "@/lib/api";

export async function duplicateProject(projectId) {
  const { data } = await api.post(`/projects/${projectId}/duplicate`);
  return data.data;
}

export async function deleteProject(projectId) {
  const { data } = await api.delete(`/projects/${projectId}`);
  return data;
}

export async function createShareLink(analysisId, ttlDays = 7) {
  const { data } = await api.post(`/analyses/${analysisId}/share`, {
    ttl_days: ttlDays,
  });
  return data.data;
}

export async function listShareLinks(analysisId) {
  const { data } = await api.get(`/analyses/${analysisId}/shares`);
  return data.data;
}

export async function revokeShareLink(shareId) {
  const { data } = await api.delete(`/shares/${shareId}`);
  return data;
}

/** Public, unauthenticated helper — bypasses the api instance auth interceptor. */
export async function fetchPublicShare(token) {
  const base = process.env.REACT_APP_BACKEND_URL;
  const res = await fetch(`${base}/api/public/share/${token}`, {
    method: "GET",
    credentials: "omit",
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.detail || `HTTP ${res.status}`);
  }
  const body = await res.json();
  return body.data;
}

export function buildShareUrl(token) {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/share/${token}`;
}
